module.exports = __webpack_public_path__ + "static/media/pan.ac69909f.svg";